// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__17opb","col":"styles_col__HaJU6"};